module.exports = __webpack_public_path__ + "img/NB-700.0caa82a1.jpeg";